import * as Cesium from 'cesium';
import MapModal from "../MapModal";
import FormField from '../FormField';
import Fab from '@mui/material/Fab';
import { MapModalTypes } from "constant";
import { useDispatch } from "react-redux";
import { Search } from '@mui/icons-material';
import React, { useState, useEffect } from "react";
import { PlaceOutlined } from '@mui/icons-material';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import useViewerStore from '../../store-zustand/viewer';
import useProjectStore from '../../store-zustand/project';
import useSearchStore from '../../store-zustand/searchbar';
import TooltipIconButton from "components/TooltipIconButton";
import { AddMarker, BBOX_CENTROID, Zoomtopoint } from '../MapView/MapUtils';

const SearchInput = ({ id, label, onChange, onClickInput, onKeyDown, placeholder, value, onCreate, page = '' }) => {
  const { viewer, setMapbox, SearchBarData: RequestSearchBarData, SearchWeatherData: RequestWeatherData, search_result_visibility, setsearch_result_visibility } = useViewerStore();
  const { setkeywords_response } = useSearchStore();
  const { setproject_modal_information } = useProjectStore();
  let [searchinputvalue, setsearchinputvalue] = useState();
  let [AutocompleteText, setAutocompleteText] = useState("Where to?");
  const [mapModal, setMapModal] = useState(null);
  const dispatch = useDispatch();

  function goToMyPosition() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }

  const locationcircle = {
    width: '48px',
    height: '48px',
    background: 'rgba(72, 123, 242, 0.25)',
    marginRight: '18px',
    ariaHidden: 'true',
    boxShadow: 'none',
    borderRadius: 30
  }

  const locationBackground = {
    pointerEvents: 'none',
    opacity: '1',
    color: '#487BF2',
    height: '24px',
    width: '24px',
    borderRadius: '0px',
    position: 'absolute',
    left: '16.67 %',
    right: '16.67 %',
    top: '8.33 %',
    bottom: '8.33 %',
    ariaHidden: 'true'
  }

  const locationtext = {
    fontSize: '16px',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '1px',
    color: '#E5E5E5',
    marginBottom: '9px',
    height: '65px',
    width: '100%',
    paddingTop: '8px',
    paddingLeft: '24px'
  }

  const subli_country = {
    marginLeft: '66px',
    color: '#A0A0A0',
    lineHeight: '1px',
    fontSize: '13px'
  }

  const subli_place_name = {
    verticalAlign: 'text-top',
    lineHeight: '5px'
  }

  const spacement_between_text = {
    marginTop: '-16px'
  }

  const search_keyworkd_data = async (keyword_value) => {
    setsearchinputvalue(keyword_value);
    setsearch_result_visibility(true);
    if (keyword_value.length > 0) {
      const response = await RequestSearchBarData(keyword_value);
      let features_result_array = [];
      if (response !== undefined) {
        response.data.features.forEach(({ context, place_name, center, properties, bbox: bbox_data }, index) => {
          let bbox = bbox_data;
          let address_data = ``;
          let place_name_data = ``;
          let postal_code_data = ``;
          let region_data = ``;
          let country_data = ``;
          let adress_of_search_tray = ``;

          if (properties.address) address_data = properties.address;

          if (context) {
            context.forEach((item) => {
              if (item.id.includes('locality')) {
                place_name_data = item.text;
              }
              else if (item.id.includes('postcode')) {
                postal_code_data = item.text;
              }
              else if (item.id.includes('region')) {
                region_data = item.text;
              }
              else if (item.id.includes('country')) {
                country_data = item.text;
              }
            })
          }

          let response_data = place_name.split(',');
          const segments_number = response_data.length;
          if (country_data === undefined || country_data === ``) {
            country_data = response_data[segments_number - 1];
            response_data.splice(segments_number);
          }

          if (region_data === undefined || region_data === ``) {
            region_data = response_data[segments_number - 2];
            response_data.splice(segments_number);
          }

          if (postal_code_data === undefined || postal_code_data === ``) {
            let code_postalk_array = place_name.match(/(\d+)/);
            if (code_postalk_array !== null) postal_code_data = code_postalk_array[code_postalk_array.length - 1];
          }

          adress_of_search_tray = place_name;
          const place_name_length = adress_of_search_tray.length;
          if (place_name_length > 27) {
            adress_of_search_tray = adress_of_search_tray.substring(0, 27);
            adress_of_search_tray = `${adress_of_search_tray} ...`;
          } else if (place_name_length === 0) {
            adress_of_search_tray = `${response_data[segments_number - 1]}, ${response_data[segments_number - 2]}`;
          }

          if (place_name_data === undefined || place_name_data === ``) place_name_data = response_data[0];
          features_result_array.push(
            <li style={locationtext} address={`${address_data}`} adress_of_search_tray={`${adress_of_search_tray}`} region={`${region_data}`} country={`${country_data}`} postal_code={`${postal_code_data}`} place_name={`${place_name_data}`} location={`${center}`} bbox={`${bbox}`} onClick={shoot} >
              <Fab adress_of_search_tray={`${adress_of_search_tray}`} address={`${address_data}`} region={`${region_data}`} country={`${country_data}`} postal_code={`${postal_code_data}`} place_name={`${place_name_data}`} location={`${center}`} bbox={`${bbox}`} style={locationcircle} >
                <PlaceOutlined style={locationBackground} />
              </Fab>
              <span style={subli_place_name} adress_of_search_tray={`${adress_of_search_tray}`} address={`${address_data}`} region={`${region_data}`} country={`${country_data}`} postal_code={`${postal_code_data}`} place_name={`${place_name_data}`} bbox={`${bbox}`} location={`${center}`} >{`${adress_of_search_tray}`}</span>
              <p adress_of_search_tray={`${adress_of_search_tray}`} address={`${address_data}`} region={`${region_data}`} country={`${country_data}`} postal_code={`${postal_code_data}`} place_name={`${place_name_data}`} bbox={`${bbox}`} location={`${center}`} style={spacement_between_text}></p>
              <span adress_of_search_tray={`${adress_of_search_tray}`} address={`${address_data}`} region={`${region_data}`} country={`${country_data}`} postal_code={`${postal_code_data}`} place_name={`${place_name_data}`} bbox={`${bbox}`} location={`${center}`} style={subli_country}>{`${region_data}, ${country_data}`}</span>
            </li>);
        });

        setkeywords_response(features_result_array);
      } else {
        alert('Error while loading data');
      }
    } else {
      setkeywords_response(' ');
    }
  }

  const shoot = async (event) => {
    if (event.target.getAttribute('location') !== null && event.target.getAttribute('bbox') !== null) {
      const location = event.target.getAttribute('location').split(",");
      let bbox_string = event.target.getAttribute('bbox');
      const bbox = bbox_string.split(',');
      const location_string = event.target.getAttribute('location');
      const place_name = event.target.getAttribute('place_name');
      const adress_of_search_tray = event.target.getAttribute('adress_of_search_tray');
      let address = event.target.getAttribute('address');
      let postal_code = event.target.getAttribute('postal_code');
      let region = event.target.getAttribute('region');
      let country = event.target.getAttribute('country');
      setAutocompleteText(adress_of_search_tray);
      if (address === 'undefined') address = '';

      let marker_coordinate = [];
      if (bbox.length <= 1) {
        Zoomtopoint(viewer, parseFloat(location[0]), parseFloat(location[1]));
        marker_coordinate[0] = parseFloat(location[0]);
        marker_coordinate[1] = parseFloat(location[1]);
      } else {
        viewer.camera.flyTo({
          destination: Cesium.Rectangle.fromDegrees(parseFloat(bbox[0]), parseFloat(bbox[1]), parseFloat(bbox[2]), parseFloat(bbox[3]))
        });
        let bbox_centre = BBOX_CENTROID(parseFloat(bbox[0]), parseFloat(bbox[2]), parseFloat(bbox[1]), parseFloat(bbox[3]));
        marker_coordinate[0] = bbox_centre[0];
        marker_coordinate[1] = bbox_centre[1];
      }

      AddMarker(viewer, 'Location_Marker', 'pin_search.svg', marker_coordinate[0], marker_coordinate[1]);

      // let weather_data_response = await RequestWeatherData(`${location[1]},${location[0]}`);
      // let temperature_value = weather_data_response ? weather_data_response.Value : '--';
      let temperature_value = '--';

      setsearchinputvalue('');
      if (page !== 'editlocation') {
        setMapModal({
          type: MapModalTypes.SearchResult,
          title: "Area Name",
          address: address,
          place_name: place_name,
          postal_code: postal_code,
          region: region,
          country: country,
          description: `${location[0]} , ${location[1]}`,
          temperature: temperature_value,
          location: location_string
        });
      }

      let project_default_name = address;
      if (address === '' || address === undefined) project_default_name = place_name;

      setproject_modal_information({
        info: {
          type: MapModalTypes.SearchResult,
          title: "Area Name",
          address: address,
          place_name: place_name,
          postal_code: postal_code,
          region: region,
          country: country,
          description: `${location[0]} , ${location[1]}`,
          temperature: temperature_value,
          location: location_string,
          projectname: project_default_name
        }
      });
    }
  }

  const handleCreate = () => {
    onCreate(mapModal);
  };

  function showPosition(position) {
    const lat = position.coords.latitude;
    const long = position.coords.longitude;
    AddMarker(viewer, 'Location_Marker', 'my-location.svg', long, lat);
    viewer.camera.flyTo({ destination: Cesium.Cartesian3.fromDegrees(parseFloat(long), parseFloat(lat), 600.0) });
  }

  useEffect(() => {
    if (mapModal) {
      dispatch({ type: 'TOGGLE_MAP_MODAL', show: true });
    } else {
      dispatch({ type: 'TOGGLE_MAP_MODAL', show: false });
    }
  }, [mapModal])

  return (
    <>
      <FormField label={label} id={id}>
        <div className="inputgroup">
          <TooltipIconButton title="My Position" aria-label="my-position" placement="right" position="true" top={2} left={0} size={44} onClick={goToMyPosition}>
            <GpsFixedIcon fontSize="large" />
          </TooltipIconButton>
          <input
            id={id}
            className="searchbarinput"
            type="text"
            placeholder={AutocompleteText}
            value={searchinputvalue}
            onChange={event => search_keyworkd_data(event.target.value)}
            onClick={() => { setAutocompleteText(''); setsearchinputvalue(''); }}
            style={{ paddingLeft: '4rem', paddingRight: '4rem' }} />
        </div>
        <TooltipIconButton title="Search" aria-label="search" placement="bottom" position="true" top={2} right={5} size={44}>
          <Search />
        </TooltipIconButton>
      </FormField>
      {mapModal && (<MapModal type={mapModal.type} info={mapModal} onChangeStatus={handleCreate} />)}
    </>
  )
}

export default SearchInput;